import styles from "gui/quote/quote.module.css";
import { Figure } from "gui/figure/figure";
import { SanityQuote } from "lib/sanity/types";

export const Quote: React.FC<{
  item: SanityQuote;
}> = (props) => {
  return (
    <article className={styles.quote}>
      <header>
        <div className={styles.person}>
          <Figure item={props.item.avatar} width={60} format="jpg" />
          <h3>{props.item.name}</h3>
          <p>{props.item.role}</p>
        </div>
        <div className={styles.company}>
          <Figure item={props.item.logo} width={150} format="png" />
        </div>
      </header>
      <blockquote>{props.item.text}</blockquote>
    </article>
  );
};
